import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import Item from "./Item";
const { Title } = Typography;

const CompanySignature = (props) => {
  const intl = useIntl();
  const organizationName = useSelector(
    (state) => state.organization.details.name
  );

  return (
    <div className="section" style={{ width: "100%" }}>
      <Title level={5}>
        {intl.formatMessage({
          id: "app.orders.company_details",
        })}
      </Title>
      <div className="rowContainer">
        <Item
          name="company_name"
          content={organizationName}
          line_type="vertical"
        />

        <div className="horizontal_spacer" />
        <Item name="company_signature" line_type="vertical" />
      </div>
    </div>
  );
};

export default CompanySignature;
